var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"}},[_c('path',{attrs:{"fill":_vm.colorx,"d":"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302a7602","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/icons/HomeIcon.vue
// module id = null
// module chunks = 